<template>
  <div class="d-popover-tooltip-arrow">
    <svg
      width="32"
      height="6"
      viewBox="0 0 24 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2865 6.00098C8.28704 6.00098 7.28715 0.000976562 1.28648 0.000976562C-4.71419 0.000976562 29.2866 0.000976563 23.2868 0.000976562C17.287 0.000976562 16.2859 6.00098 12.2865 6.00098Z"
        :fill="backgroundColor"
      />
    </svg>
  </div>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    props: {
      backgroundColor: {
        type: String,
        default: 'var(--color-grey-10)',
      },
    },
  })
</script>
